import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { TestProvider } from './contexts/TestContext';
import { CookieProvider } from './contexts/CookieContext';
import Home from './components/Home/Home';
import AreaSelection from './components/AreaSelection/AreaSelection';
import Quiz from './components/Quiz/Quiz';
import Results from './components/Results/Results';
import Privacy from './components/Privacy/Privacy';
import Terms from './components/Terms/Terms';
import Contact from './components/Contact/Contact';
import CookiePolicy from './components/Cookies/CookiePolicy';
import CookieBanner from './components/Cookies/CookieBanner';
import Header from './components/common/Header';
import Footer from './components/common/Footer';
import './styles/App.css';

function App() {
  return (
    <CookieProvider>
      <TestProvider>
        <Router>
          <div className="app">
            <Header />
            <main className="main-content">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/area-selection" element={<AreaSelection />} />
                <Route path="/quiz/:areaId" element={<Quiz />} />
                <Route path="/results" element={<Results />} />
                <Route path="/privacidad" element={<Privacy />} />
                <Route path="/terminos" element={<Terms />} />
                <Route path="/contacto" element={<Contact />} />
                <Route path="/cookies" element={<CookiePolicy />} />
              </Routes>
            </main>
            <Footer />
            <CookieBanner />
          </div>
        </Router>
      </TestProvider>
    </CookieProvider>
  );
}

export default App;
